import { HttpContextToken } from '@angular/common/http';

export const USER_TRIGGERED_REQUEST = new HttpContextToken<boolean>(() => false);
export const LOCAL_ERROR_HANDLED = new HttpContextToken<boolean>(() => false);
export const PASSIVE_REQUEST = new HttpContextToken<boolean>(() => false);
